import React from "react";
import "./Notification.css";
import ListGroup from "react-bootstrap/ListGroup";
import { Link } from "react-router-dom";
import Moment from "moment";

class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.props.onClose(this.props.notification.id);
  }

  render() {
    const updateTime = Moment(this.props.notification.updated_at * 1000).format(
      "YYYY/M/D HH:mm:ss"
    );
    const checkTime =
      this.props.notification.checked_at == null
        ? ""
        : Moment(this.props.notification.checked_at * 1000).format(
            "YYYY/M/D HH:mm:ss"
          );

    let issue;
    let bookType;
    let issueID;

    const titleID = this.props.notification.title.id;
    const title = this.props.notification.title.name;

    if (this.props.notification.pdf_book.id != null) {
      issue =
        this.props.notification.pdf_book.issue == null
          ? ""
          : this.props.notification.pdf_book.issue;
      issueID = this.props.notification.pdf_book.id;
      bookType = "pdf_books";
    } else {
      issue =
        this.props.notification.web_content_book.issue == null
          ? ""
          : this.props.notification.web_content_book.issue;
      issueID = this.props.notification.web_content_book.id;
      bookType = "web_content_books";
    }

    const linkUri = `${
      process.env.REACT_APP_URL_ROOT
    }titles/${titleID}/${bookType}/${issueID}`;

    return (
      <ListGroup.Item>
        <div className="notification_content">
          <Link to={linkUri} className="noti_link">
            {title + " " + issue}
          </Link>{" "}
          <br />
          [Completed] {updateTime}
          <br />
          {checkTime && <p>[Checked] {checkTime}</p>}
        </div>

        {this.props.isAdmin && checkTime && (
          <button
            type="button"
            className="close notification_close_btn"
            aria-label="Close"
            onClick={this.handleClose}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        )}
      </ListGroup.Item>
    );
  }
}

export default Notification;
